// // Action names should be imported from their respective action modules
import {
    ACCESS_COMPONENT_BEGIN,
    ACCESS_COMPONENT_SUCCESS,
    ACCESS_COMPONENT_FAILURE,
    ACCESS_COMPONENT_CLEAR,
} from '../actions/AccessComponentActions';

// Example initial state
const initialState = {
    item: {},
    isLoading: false,
    error: ''
};

// Return a new state object with updated attributes
export default function AccessComponentReducer(state = initialState, action) {
    switch (action.type) {
        case ACCESS_COMPONENT_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case ACCESS_COMPONENT_SUCCESS:
            return {
                ...state,
                item: action.payload.data,
                isLoading: false,
                error: ''
            }
        case ACCESS_COMPONENT_FAILURE:
            return {
                ...state,
                error: action.payload.error,
                isLoading: false
            }
        case ACCESS_COMPONENT_CLEAR:
            return {
                ...state,
                item: {},
                isLoading: false
            }
        default:
            return state;
    }
};


export const accessComponentError = state => {
    return state.error;
}

export const accessComponentIsLoading = state => {
    return state.isLoading;
}

export const accessComponent = state => {
    return state.item;
}